import { camelCaseToHuman } from '../../../utils/utils';
import { DefaultPrimaryHeader, HeaderBlock, StatusSecondary } from '../activityFeedHeaderShared';

function LicenseIssueRemediatedHeader({ entity, linkProps }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={camelCaseToHuman(entity?.issueName)} activity="remediated" linkProps={linkProps} />}
      secondary={<StatusSecondary previous={entity?.entityUpdates?.[0]?.previous} current={entity?.entityUpdates?.[0]?.current} />}
    />
  );
}

export default LicenseIssueRemediatedHeader;
